// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2bxDB","footer":"ReportModalFilter_footer__UaAhe"};